// extracted by mini-css-extract-plugin
export default {"heading":"heading---B1Uol","rowMargin":"rowMargin---vWXHl"};